import { z } from 'zod';

export const InfluencerManagersSchema = z.object({
  managerIds: z.array(z.object({ id: z.string() }))
});

export type InfluencerManagersFormValues = z.infer<typeof InfluencerManagersSchema>;
